export const schoolItems = {
    id: 0,
    name: '',
    districtId: 0,
    created: new Date(),
    status: 0,
    baseId: 0,
    visibility: 0,
    slug: '',
    who: '',
    schoolUsers: [],
    products: [],
    productOptions:[]

}
export const schoolUserItems = {
    id: null,
    isApprover: false,
    fullName: '',
    email: '',
    password: '',
} 

 